<template>
    <div class="taxo-setup container-fluid">
        <CRow class="pr-2">
    <CCol col="10" xl="10" class="p-0">
      <CCard >
        <CCardBody>

   <a-card class="edit-card"  style="margin:0; padding:0;"  :body-style="{padding:0}">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted">Typ obsahu</h6>
                            <template v-if="contenttype.title">{{contenttype.title}}</template><template v-else>Nový typ obsahu</template></span>
                            <span slot="extra">
<template v-if="actualTab == 'fields'"> <a-button type="primary" class="float-right ml-2"  @click="openFieldModal">Pridať pole</a-button>
                                    <a-button type="primary" class="float-right"  @click="openGroupModal">Pridať skupinu</a-button></template>

                  </span>




            <a-tabs v-model="actualTab" tab-position="left" class="mt-3 mb-3">
  <a-tab-pane tab="Nastavenia" key="setup">


                        <div class="pl-lg-4 p-3">

                                          <a-form-item label="Názov"  :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                            <a-input alternative=""
                                                        input-classes="form-control-alternative"
                                                        v-model="contenttype.title"
                                            /></a-form-item>

                                          <a-form-item label="Slug" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                            <a-input alternative=""
                                                        input-classes="form-control-alternative"
                                                        v-model="contenttype.slug"
                                            />
                                          </a-form-item>


                                    <template v-if="productCat.length > 0">
                                      <a-form-item label="Kategória produktu" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                            <a-select defaultValue="1" v-model="contenttype.product" :options="productCat">
                                                 <template v-for="item in productCat">
                                                 <a-select-option :key="item.value" :value="item.value" >{{item.label}}</a-select-option></template>
                                            </a-select>
                                            </a-form-item>
                                      </template>
                                    <template v-if="ctnodes">
                                      <a-form-item label="Breadcrumbs nastavenia" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                        <a-select v-if="ctnodes" mode="multiple" class="w-100" v-model="contenttype.breadcrumbs" :options="ctnodes"/>
                                      </a-form-item>
                                    </template>
                                        <template v-if="fieldStoShow">
                                       <!-- ... existujúci form-item Zobraziť polia ... -->
<a-form-item label="Zobraziť polia" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
<a-select mode="multiple" v-model="contenttype.showon" class="w-100">
  <template v-for="item in fieldStoShow">
    <!-- číslo, nie string -->
    <a-select-option :key="item.value" :value="item.value">
      {{ item.label }}
    </a-select-option>
  </template>
</a-select>



  <!-- settings button -->
  <div class="mt-2 text-right">
    <a-button
      icon="setting"
      @click="openShowonSetupModal"
      :disabled="!contenttype.showon || !contenttype.showon.length"
    >Nastaviť šírky</a-button>
  </div>
</a-form-item>

<!-- Modal: šírky pre vybrané showon polia -->
<!-- Tlačidlo ostáva rovnaké -->
<a-modal
  v-model="showonSetupVisible"
  :title="'Zobraziť polia – šírky (px)'"
  centered
  @ok="saveShowonSetup"
>
  <div v-if="!contenttype.showon || !contenttype.showon.length" class="text-muted">
    Najprv vyber polia v „Zobraziť polia“.
  </div>

  <div v-else>
<a-row :gutter="12" v-for="fid in contenttype.showon" :key="'showon-'+fid" class="mb-2">
  <a-col :span="14"><b>{{ fieldLabel(fid) }}</b></a-col>
  <a-col :span="10" class="d-flex align-items-center" style="gap:8px;">

    <a-input-number
      :min="0"
      :step="10"
      :value="widthPx(fid)"
      @change="val => setWidthPx(fid, val)"
      @input="val => setWidthPx(fid, val)"
      style="width: 120px;"
      placeholder="px"
    />
    <span class="text-muted">px (0 = ignorovať)</span>
  </a-col>
</a-row>


  </div>
</a-modal>


                                        </template>
                                        <template v-if="fieldStoShow">
                                          <a-form-item label="Kategorizácia"  :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                            <a-select v-model="contenttype.maincategory" class="w-100">

                                                <a-select-option value="">Nepriradené</a-select-option>
                                                <template v-for="item in contenttype.fields">
                                                 <a-select-option :key="item.id" v-if="item.type == '12'" :value="item.id" >{{item.title}}</a-select-option></template>
                                            </a-select>
                                            </a-form-item>

                                        </template>

                                          <a-form-item label="Umožniť revízie typu obsahu" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                            <a-checkbox class="mb-3" v-model="contenttype.revisions"></a-checkbox>
                                            </a-form-item>


                                            <a-form-item label="Zverejniť v site mape" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                               <a-checkbox class="mb-3" v-model="contenttype.sitemap"></a-checkbox>
                                               </a-form-item>

                                               <a-form-item label="Priorita" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                                                <a-select v-model="contenttype.priority" class="w-100" :options="priority" />
                                                </a-form-item>

                        </div>
                        </a-tab-pane>
                          <a-tab-pane tab="Bloky" key="blocks">  <div class="p-3" v-if="contenttype.blocks">

                        <a-card shadow type="secondary">
                            <div class="header bg-white border-0">
                                <div class="row align-items-center">
                                    <div class="col-8">
                                        <h3 class="mb-0">Usporiadanie blokov</h3>
                                    </div>
                                    <div class="col-4 text-right">
                                    </div>
                                </div>
                            </div>
                            <draggable @change="updateBlocks" v-bind="dragOptions" v-model="contenttype.blocks" group="newcomponents" @start="drag=true" @end="drag=false" handle=".handle">
                                <transition-group>
                                    <template v-for="(child, index) in contenttype.blocks">
                                        <div :key="':' + index + child.id" class="hideimages element"><span>
                                            <a class="handle"><i class="fad fa-expand-arrows-alt"></i></a><a><em >{{child.component}}</em> <b v-if="child.des">{{child.des | truncate(30)}} </b> <b>({{child.language}})</b> </a>



                                              <router-link :to="'/block/' + child.id" v-if="child.id > 0"  class="" :href="'/block/' + child.id">
                                                  <a-button type="secondary" class="add-button edit-button"  icon="fas fa-pencil-alt">Uprav</a-button>
                                              </router-link>

                                              <router-link :to="'/block/' + child.showon" v-else  class="" :href="'/block/' + child.showon">
                                                  <a-button type="secondary"  class="add-button edit-button"  icon="fas fa-pencil-alt">Uprav</a-button>
                                              </router-link>


                                               </span>
                                        </div>
                                    </template>
                                </transition-group>
                            </draggable>
                            <div class="text-right mt-3">
                                <button class="btn btn-primary" @click="saveReorder">Uložiť</button>
                            </div>  </a-card>

                </div>
                </a-tab-pane>
                 <a-tab-pane tab="Polia" key="fields">
  <div class="pl-lg-4 p-3">
                   <a-modal :title="parseInt(newField.id) ? 'Úprava poľa' : 'Nové pole'" centered  v-model="addFieldModal" v-if="addFieldModal" @ok="handleNewFieldSubmit">
                        <div class="additional-setup">
                            <div>
                                 <div class="row">
                                    <div class="col-md-12">
                                      <a-form-item label="Názov poľa" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                        <a-input placeholder="Názov poľa" v-model="newField.title"></a-input>
                                      </a-form-item>
                                    </div>
                                    <div class="col-md-12">
                                      <a-form-item label="Slug" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                        <a-input placeholder="Slug" v-model="newField.slug"></a-input>
                                      </a-form-item>
                                    </div>
                                    <div class="col-md-12" v-if="!parseInt(newField.id)">
                                      <a-form-item label="Typ poľa" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                        <a-select defaultValue="1" v-model="newField.type" @change="handleChange" :options="types" class="w-100" style="min-height:40px;"/>
                                      </a-form-item>
                                    </div>

                                    <div class="col-md-12" v-if="newField.slug == 'seodescription' || newField.slug == 'seotitle'">
                                        <a-input placeholder="Globálne nastavenia" v-model="newField.setup"></a-input>
                                    </div>
                                    <template v-if="(newField.type === '8' || newField.type === '22')">
                                        <div class="col-md-12">


       <a-form-item label="Typ obsahu" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-select defaultValue="1" v-model="newField.content_type" class="w-100" style="min-height:40px;">
          <template v-for="k in contenttypes"><a-select-option :key="k.id" :value="k.id">{{k.title}}</a-select-option></template>
      </a-select>   </a-form-item>
      <a-form-item label="Polia" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-select defaultValue="1"  mode="multiple" v-model="newField.fieldoptions" class="w-100" style="min-height:40px;">
          <template v-for="k in subfields"><a-select-option v-if="k.type != 20" :key="k.id" :value="k.slug">{{k.title}}</a-select-option></template>
      </a-select>

                                            </a-form-item>

                                        </div>
                                    </template>
                                     <template v-if="newField.type === '28'">
                                        <div class="col-md-12" >
                                            <a-form-item label="Typ obsahu" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
      <a-select defaultValue="1" v-model="newField.setup" class="w-100" style="min-height:40px;">
          <template v-for="k in contenttypes"><a-select-option :key="k.id" :value="k.id">{{k.title}}</a-select-option></template>
      </a-select>   </a-form-item>

                                               <a-form-item label="Administračné polia" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
      <a-select defaultValue="1"  mode="multiple" v-model="newField.fieldoptions" class="w-100" style="min-height:40px;">
          <template v-for="k in subfields"><a-select-option v-if="k.type != 20" :key="k.id" :value="k.slug">{{k.title}}</a-select-option></template>
      </a-select>

                                            </a-form-item>
                                        </div>
                                    </template>
                                    <template v-if="newField.type === '12' && !parseInt(newField.id)">
                                        <div>

<a-form-item label="Slovníky taxonómie" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                            <a-radio-group v-decorator="['radio-group']" v-model="newField.content_type">
                                                <a-form-item :label="k.title" :key="k" :label-col="{ span: 22 }" :wrapper-col="{ span: 2 }" v-for="k in taxonomies">
                                                    <a-radio class="mb-3" :value="k.id" />
                                                </a-form-item>
                                            </a-radio-group>
                                          </a-form-item>
                                            <h6 class="heading-small text-muted mb-4">Multi pole</h6>
                                            <a-switch @change="onChange" />
                                        </div>
                                    </template>
                                    <div class="col-md-12 mt-1" v-if="newField.type === '17' && !parseInt(newField.id)">
  <a-form-item
                                                v-for="k in form.getFieldValue('keys')"
                                                :key="k"
                                                :labelCol="labelCol" :wrapperCol="wrapperCol"
                                                v-bind="formItemLayout"
                                                :required="false"

                                        >
                                            <a-input  v-model="newField.fieldcolection.title[k]" class="w-100" placeholder="Názov"/>
                                            <a-select defaultValue="1" :options="types" class="w-100"  v-model="newField.fieldcolection.type[k]" placeholder="Typ poľa"/>
<div v-if="newField.fieldcolection.type[k] === '12'">
<a-select defaultValue="1" :options="taxs" v-model="newField.fieldcolection.setup[k]" class="w-100"  placeholder="Vyberte slovník taxonómie"></a-select>
</div>
                                            <a-icon
                                                    v-if="form.getFieldValue('keys').length > 1"
                                                    class="dynamic-delete-button"
                                                    type="minus-circle-o"
                                                    :disabled="form.getFieldValue('keys').length === 1"
                                                    @click="() => remove(k)"
                                            />
                                        </a-form-item>
                                        <a-form-item>
                                            <a-button type="dashed" style="width: 60%; float:left" @click="add">
                                                <a-icon type="plus" /> Pridaj pole
                                            </a-button>
                                        </a-form-item>
                                    </div>

                                    <div class="col-md-12" v-if="newField.type === '2' && newField.slug != 'language'" >
                                        <a-form-item
                                                v-for="k in form.getFieldValue('keys')"
                                                :key="k"
                                                v-bind="formItemLayout"
                                                style="margin-top:10px;"
                                                :required="false"

                                        >
                                            <a-input style="float:left;width:45%; margin-right:2%;" v-model="newField.options[k].title" placeholder="Názov"/>
                                            <a-input style="float:left;width:45%;" v-model="newField.options[k].slug" placeholder="Slug"/>

                                            <a-icon
                                                    v-if="form.getFieldValue('keys').length > 1"
                                                    class="dynamic-delete-button"
                                                    style="position:relative;left:10px;top:-3px;"
                                                    type="minus-circle-o"
                                                    :disabled="form.getFieldValue('keys').length === 1"
                                                    @click="() => remove(k)"
                                            />
                                        </a-form-item>
                                        <a-form-item >
                                            <a-button type="primary" style="margin-top:20px;text-align:left;" @click="add"> + Pridať</a-button>
                                        </a-form-item>
                                    </div>
                                </div>
                                <a-form-item label="Multirozmerné pole" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.multibool"></a-checkbox>
                              </a-form-item>
                              <a-form-item label="Samostatne preložiteľné pole" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.translatablebool" ></a-checkbox>
                              </a-form-item>
                             <a-form-item label="Neprekladať pole" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.translatebool" ></a-checkbox>
                              </a-form-item>
                                <a-form-item label="Jazykovo nezávislá položka" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.independentbool" ></a-checkbox>
                              </a-form-item>
                                <a-form-item label="Plánovateľná položka" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.schedulablebool" ></a-checkbox>
                              </a-form-item>
                             <a-form-item label="Pole s históriou" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.historicbool" ></a-checkbox>
                              </a-form-item>
                                <a-form-item label="Filtrovateľná položka" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.filterablebool"></a-checkbox>
                              </a-form-item>
                              <template v-if="newField.type == '4'">
                                <a-form-item label="Zobraz celý text v zozname" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.extrabool"></a-checkbox>
                              </a-form-item>
                                </template>
                            </div>
                        </div>
                    </a-modal>





                    <a-modal :title="'Nová skupina'" centered  v-model="addGroupModal" v-if="addGroupModal" @ok="handleNewGroupSubmit">


                                    <div class="w-100" v-if="grouping">
                                        <a-form-item label="Vybrať z existujúcich termínov">
                                            <a-select defaultValue="1" v-model="groupField.groupID" :options="grouping" class="w-100"/>
                                        </a-form-item>
                                              <a-form-item label="Vytvoriť nový termín">
                                              <a-row :gutter="12">
                                                <a-col :span="17"><a-input type="text" v-model="newTermToAdd"></a-input> </a-col>
                                                <a-col :span="7"><a-button @click="addTerm()" class="mr-1">+ pridať termín</a-button></a-col>
                                              </a-row></a-form-item>

                        </div>
                    </a-modal>




<div>
    <div class="control_wrapper">
        <ejs-treeview  id='treeview' :nodeDragStop='dragStop' :fullRowSelect='false'
                      :fullRowNavigable='false' :nodeDragging='nodeDrag' @dataSourceChanged="updateFields" v-model="fields"
                      :nodeTemplate="treeTemplate"  :allowEditing='false' :fields="fields" :allowDragAndDrop='true' :nodeClicked='nodeclicked'>
            <ejs-contextmenu id='contentmenutree' target='#treeview' :items='menuItems' :beforeOpen='beforeopen' :select='menuclick'></ejs-contextmenu>
        </ejs-treeview>
    </div>
</div>
  </div>

                    </a-tab-pane>
                    <a-tab-pane tab="Obmedzenia používateľa" key="userlimit">
                      <a-form-item label="Limitovať na základe poľa" :labelCol="{ span: 24 }" :wrapperCol="{ span: 22 }">
                        <a-select v-model="contenttype.limitbyfield" placeholder="Vyber kľúčové pole" style="width:100%;" allowClear>

                         <template v-for="field in userFields">
                          <a-select-option
                          v-if="field.type == '12' || field.type == '8'"
                            :key="field.id" :value="field.id">
                            {{ field.title }}
                          </a-select-option>
                          </template>
                        </a-select>

                      </a-form-item>

                    </a-tab-pane>
     <a-tab-pane tab="Nastavenia importu" key="xlsx">
 <a-upload name="import" :multiple="false" :customRequest="importExampleFile" :headers="head" :showUploadList="false">
                  <a-button>Import vzorového súboru</a-button>
                  </a-upload>

                  <div v-if="sheetRows.length" class="mt-4" style="max-width:98%;">
    <h4>Mapa importu</h4>
    <a-row>
      <a-col :span="12">
<a-table
  :dataSource="tableRows"
  :columns="importColumns"
  rowKey="key"
  :pagination="false"
  size="small"
/>

      </a-col>

      <a-col :span="12" class="pl-4">
      <div class="d-flex align-items-center">
      <a-form-item label="Výber počiatočného riadka" :labelCol="{ span: 24 }" :wrapperCol="{ span: 24 }">
        <a-button @click="previewRow = Math.max(0, previewRow-1)">←</a-button>
        <a-input-number v-model="previewRow" :min="0" :max="sheetRows.length-1" class="mx-2" style="width:100px" />
        <a-button @click="previewRow = Math.min(sheetRows.length-1, previewRow+1)">→</a-button>
        <span class="ml-2 text-muted">/ {{ sheetRows.length-1 }}</span>
      </a-form-item>
      </div>
<a-form-item label="Preskočiť prvý riadok" :labelCol="labelCol3"
    :wrapperCol="wrapperCol3">
  <a-checkbox v-model="ignoreHeader">Ignorovať prvý riadok</a-checkbox>
</a-form-item>
<a-form-item label="Názov importu" :labelCol="labelCol3"
    :wrapperCol="wrapperCol3">
  <a-input placeholder="Názov uploadu" v-model="uploadName" />
</a-form-item>

  <!-- Výber kľúčového poľa -->
  <a-form-item
    label="Kľúčové pole"
   :labelCol="labelCol3"
    :wrapperCol="wrapperCol3"
  >
    <a-select
      v-model="keyField"
      placeholder="Vyber kľúčové pole"
      style="width:100%;"
      allowClear
    >
    <template v-for="field in contenttype.fields">
      <a-select-option
      v-if="field.type != '20' && field.type != '12' && field.type != '8'  && field.type != '2'  && field.type != '3'   && field.type != '7'  && field.type != '11'"
        :key="field.id"
        :value="field.id"
      >
        {{ field.title }}
      </a-select-option>
      </template>
    </a-select>
  </a-form-item>

  <!-- Správanie pri existujúcom zázname -->
  <a-form-item
    label="Pri existujúcom zázname"
    :labelCol="labelCol3"
    :wrapperCol="wrapperCol3"
  >
    <a-select
      v-model="existingBehavior"
      style="width:100%;"
    >
      <a-select-option value="skip">Preskočiť, ak existuje</a-select-option>
      <a-select-option value="update">Aktualizuj, ak existuje</a-select-option>
      <a-select-option value="updateonly">Aktualizuj, ak existuje, ale nevytváraj ak nie</a-select-option>
    </a-select>
  </a-form-item>


  <div class="text-center">
        <a-button type="primary" class="mt-3" @click="saveMapping">Uložiť mapu importu</a-button>
</div>


      </a-col>
    </a-row>
  </div>

     </a-tab-pane>

     <a-tab-pane tab="Importovať" key="xlsximport">
  <a-table
    :dataSource="imports"
    :pagination="false"
    rowKey="id"
    size="small"
  >
    <a-table-column title="Názov"   dataIndex="setup.uploadName"/>
    <a-table-column title="Vytvorené" dataIndex="created"/>
    <a-table-column class="text-right">
      <template #default="record">
        <a-button type="primary" @click="openImpModal(record)">Priprav import</a-button>
        <a-button class="ml-2" @click="openEditMapping(record)">Upraviť</a-button>
      </template>
    </a-table-column>
  </a-table>

  <!-- modal -->
  <a-modal
    :title="'Import – ' + (impSelected && impSelected.setup
                         ? impSelected.setup.uploadName
                         : '')"
  :visible.sync="impModal"
   @cancel="impModal = false"
    @ok="runImport"
    :okButtonProps="{ disabled: !impFileUri || impUploading }"
    okText="Spusti import"
    cancelText="Zavrieť"
  >
    <p>Vyber XLSX súbor, ktorý má byť importovaný podľa tejto šablóny.</p>

    <a-upload
      name="import"
      :customRequest="uploadRealFile"
      :showUploadList="false"
      :disabled="impUploading"
    >
      <a-button :loading="impUploading">Nahrať XLSX</a-button>
    </a-upload>

    <div v-if="impFileUri" class="mt-3 text-success">
      Súbor nahratý ✔︎
    </div>
  </a-modal>
</a-tab-pane>

               </a-tabs>
                    </a-card>
                    </CCardBody>
                    </CCard>
                    </CCol>

                    <CCol col="2" xl="2" class="pl-0">
    <CCard class="p-0 pt-2 filter-side">
   <CCardBody>

          <a-card class="edit-card" style="margin:0; margin-top:10px" :body-style="{padding:0}">
      <div class="option-buttons">

      <router-link  :to="'/content/' + contenttype.slug"><a-button class="fs-12">Zobraz obsah typu  <span style="text-transform:lowercase;margin-left:3px;"> {{ contenttype.title }}</span></a-button></router-link>
      <router-link :to="'/add-content/' + contenttype.slug"><a-button>Nový obsah typu <span style="text-transform:lowercase;margin-left:3px;"> {{ contenttype.title }}</span></a-button></router-link>
      <a-button type="primary" @click="handleSubmit">Uložiť typ obsahu</a-button>
    </div>
  </a-card>
  </CCardBody>
</CCard>
  </CCol>
</CRow>

                </div>

</template>
<script>
    import {API_URL} from "../api";
    import {getURL} from "../api";
    import * as XLSX from 'xlsx'
    import {authHeader} from "../_helpers";
    import {dataService} from "../_services";
    import Vue from "vue"
    import FormItem from 'ant-design-vue'
    import AFormItem from "ant-design-vue/es/form/FormItem";
    import draggable from "vuedraggable";
    import { TreeViewPlugin } from "@syncfusion/ej2-vue-navigations";
    import treeTemplateVueFields from "./content/tree-templateField.vue";
    Vue.use(TreeViewPlugin);
    import { Modal } from 'ant-design-vue'
    import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";
    Vue.use(ContextMenuPlugin);
    Vue.use(FormItem);
    const columns = [
        {
            title: 'Názov menu',
            dataIndex: 'title',
            sorter: true,
            width: '20%',
        },
        {
            title: 'URL',
            dataIndex: 'url',
        },
        {
            align: 'right',
            scopedSlots: {customRender: 'name'},
        }
    ];

    const columns2 = [
        {
            title: 'Name',
            dataIndex: 'title',
            sorter: true,
            width: '20%',
        },
        {
            title: 'Typ poľa',
            dataIndex: 'type',
            scopedSlots: {customRender: 'cttype'},
        },
        {
            title: 'Slug',
            dataIndex: 'slug',
        },
        {
            align: 'right',
            scopedSlots: {customRender: 'name'},
        }
    ];
    let id = 0;
    export default {
        name: 'contenttype',
        components: {AFormItem, draggable},
        props: ['id'],
        data() {
            return {
                data: [],
                colorsto: JSON.parse(localStorage.colors),
                treeTemplate: function() {
                    return {
                        template: treeTemplateVueFields
                    };
                },
                menuItems : [
                    { text: 'Upraviť' },
                    { text: 'Zmazať' },
                ],
                fields: {},
                mappingId: null,
                uploadedXlsxUrl: null,
                limitByField: [],
                showonSetupVisible: false,
                showonLocal: {},
                userFields:{},
                newTermToAdd:"",
                sheetRows: [],
                currentRow: 0,
                mappings: [],
                ignoreHeader: true,
                uploadName: '',
                previewRow: 0,
                labelCol: { span: 10 },
                wrapperCol: { span: 14 },
                labelCol2: { span: 4 },
                wrapperCol2: { span: 20 },
                fieldStoShow: [],
                labelCol3: { span: 8 },
                wrapperCol3: { span: 14 },
                keyField: null,
                existingBehavior: 'skip',
                subfields:{},
                actualTab: 'setup',
                newField: {
                    title : null,
                    type : null,
                    blocks: [],
                    options : [{title: '', slug: ''}],
                    fieldcolection: {'title':[],'type':[],'setup':[]},
                    multi: false,
                    multibool: false,
                    independentbool: false,
                    schedulablebool: false,
                    setup: false,
                    filterablebool: false,
                    historicbool: false,
                    extrabool: false,
                    translatablebool: false,
                    translatebool: false,
                    slug : null,
                    content_id : this.id
                    },
                groupField: {
                groupID : null,
                content_id : this.id
                },
                loading: false,
                contexts:[],
                imports: [],
                impModal: false,
                impSelected: null,
                impFileUri: '',
                impUploading: false,
                ctnodes:{},
                fieldStoShow:{},
                allFields:{},
                url: getURL(),
                addFieldModal:false,
                addGroupModal:false,
                columns,
                columns2,
                priority: [
                    {"value" : '1.0' ,"label" : '1.0 (najviac)'},
                    {"value" : '0.9' ,"label" : '0.9'},
                    {"value" : '0.8' ,"label" : '0.8'},
                    {"value" : '0.7' ,"label" : '0.7'},
                    {"value" : '0.6' ,"label" : '0.6'},
                    {"value" : '0.5' ,"label" : '0.5 (normálna)'},
                    {"value" : '0.4' ,"label" : '0.4'},
                    {"value" : '0.3' ,"label" : '0.3'},
                    {"value" : '0.2' ,"label" : '0.2'},
                    {"value" : '0.1' ,"label" : '0.1'},
                    {"value" : '0.0' ,"label" : '0.0 (najmenej)'}
                ],
                types: [
                    {"value" : '1' ,"label" : 'Text'},
                    {"value" : '2' ,"label" : 'Výberovník'},
                    {"value" : '3' ,"label" : 'Obrázok'},
                    {"value" : '4' ,"label" : 'Dlhý text'},
                    {"value" : '5' ,"label" : 'Celé číslo'},
                    {"value" : '6' ,"label" : 'Desatiné číslo'},
                    {"value" : '7' ,"label" : 'Logická hodnota Áno/Nie'},
                    {"value" : '8' ,"label" : 'Priradenie pod typ obsahu'},
                    {"value" : '9' ,"label" : 'Dynamická hodnota'},
                    {"value" : '10' ,"label" : 'BetaEditor'},
                    {"value" : '11' ,"label" : 'Galéria obrázkov'},
                    {"value" : '12' ,"label" : 'Priradenie pod taxonómiu'},
                    {"value" : '13' ,"label" : 'Priradenie pod taxonómiu s násobkom'},
                    {"value" : '14' ,"label" : 'Dátum'},
                    {"value" : '15' ,"label" : 'Multipole - vlastnosti'},
                    {"value" : '16' ,"label" : 'Dátum od - do'},
                    {"value" : '17' ,"label" : 'Multipole'},
                    {"value" : '18' ,"label" : 'Ikona'},
                    {"value" : '19' ,"label" : 'Súbor'},
                    {"value" : '20' ,"label" : 'Skupina'},
                    {"value" : '21' ,"label" : 'Mapa'},
                    {"value" : '22', "label" : 'Priradenie konkrétneho obsahu'},
                     {"value" : '28' ,"label" : 'Spätné priradenie typu obsahu'}
                ],
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 4 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 24 },
                    },
                },
                formItemLayoutWithOutLabel: {
                    wrapperCol: {
                        xs: { span: 24, offset: 0 },
                        sm: { span: 20, offset: 4 },
                    },
                },
                head: authHeader(),
                send: API_URL,
                  contenttypeId: {
                    uid: this.id
                },
                contenttypes: [],
                productCat: {},
                grouping: {},
                taxs:{},
                contenttype: {
                    title: '',
                    type: '',
                    product : '',
                    limitbyfield: []
                },
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this, { name: 'dynamic_form_item' });
            this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
        },


        computed: {
tableRows () {
  const src = this.sheetRows[this.previewRow] || []

  return this.mappings
    .map((_, i) => ({
      key: i,
      val: src[i] !== undefined ? src[i] : ''
    }))
    /* ⬇️ nechaj len riadky, kde je aspoň 1 znak po trim() */
    .filter(r => String(r.val).trim() !== '')
},
 importColumns() {
    return [
      { title: 'Hodnota', dataIndex: 'val' },
      {
        title: 'Priradenie poľa',
        dataIndex: 'map',
        customRender: (text, row) => this.renderSelect(row.key)
      }
    ]},
  importTableColumns() {
    return [
      { title: 'Hodnota', dataIndex: 'val' },
      {
        title: 'Priradenie poľa',
        dataIndex: 'map',
        customRender: (text, row) => {
          return this.$createElement(
            'a-select',
            {
              props: {
                value: this.mappings[row.key].fieldId,
                allowClear: true
              },
              style: { width: '100%' },
              on: {
                change: val => { this.mappings[row.key].fieldId = val }
              }
            },
            [
              this.$createElement('a-select-option', { props:{value:'IGNORE'} }, '— ignorovať —'),
               ...this.contenttype.fields
          .filter(f => f.type !== "20")
          .map(f =>
            this.$createElement(
              'a-select-option',
              { props: { value: String(f.id) } },
              f.title
            )
          )
            ]
          )
        }
      }
    ]
  },
            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },
watch: {
  'contenttype.showon': {
    handler(newVal) {
      if (!this.contenttype) return;
      const { map, shape, keyName, valName } = this.normalizeShowonSetup();

      const sel = new Set((newVal || []).map(v => String(v)));

      // odstráň nezvolené
      Object.keys(map).forEach(k => { if (!sel.has(k)) delete map[k]; });

      // doplň novovybrané na 0
      sel.forEach(k => { if (!(k in map)) map[k] = 0; });

      this.persistShowonSetup(map, shape, keyName, valName);
    }
  }
},
        methods: {
            async openEditMapping(record) {

    const setup = record.setup;
    this.mappingId       = record.id;
    this.uploadedXlsxUrl = setup.fileUri;
    this.ignoreHeader    = setup.ignoreHeader;
    this.uploadName      = setup.uploadName;
    this.previewRow      = setup.startRow || 0;

    this.keyField         = setup.keyField ?? null;
    this.existingBehavior = setup.existingBehavior ?? 'skip';

    // 1) Načítaj sheetRows
    await this.parseWorkbook(setup.fileUri);

    // 2) Predvyplň mappings (môžu obsahovať createMissingTerm, ignoreIfNoLocal)
    this.mappings = setup.mappings.map(m => ({
      col:                m.col,
      sep:                m.sep,
      parts:              m.parts.length
                          ? m.parts.map(p => ({ fieldId: p.fieldId }))
                          : [{ fieldId: null }],
      createMissingTerm:  !!m.createMissingTerm,
      ignoreIfNoLocal:    !!m.ignoreIfNoLocal,
       matchBySlug      : m.matchBySlug || ''
    }));

    // 3) Prepni na kartu
    this.actualTab = 'xlsx';
  },fieldLabel(fid) {
  const f = (this.fieldStoShow || []).find(o => String(o.value) === String(fid));
  return f ? f.label : `#${fid}`;
},

openShowonSetupModal() {
  if (!this.contenttype.showon_setup || typeof this.contenttype.showon_setup !== 'object') {
    this.$set(this.contenttype, 'showon_setup', {});
  }

  const local = {};
  (this.contenttype.showon || []).forEach(fid => {
    const key = String(fid);
    const raw = this.contenttype.showon_setup[key];
    const n = parseInt(raw, 10);            // ← toto je zásadné
    local[key] = Number.isFinite(n) ? Math.max(0, n) : 0;
  });

  this.showonLocal = local;                  // nahradenie referencie → reaktívne
  this.showonSetupVisible = true;
},
normalizeShowonSetup() {
  const setup = this.contenttype && this.contenttype.showon_setup;
  const map = {};
  let shape = 'object';       // 'object' | 'array-pairs' | 'array-objects'
  let keyName = 'id', valName = 'width';

  if (Array.isArray(setup)) {
    // zisti pod-tvar
    if (setup[0] && Array.isArray(setup[0])) {
      shape = 'array-pairs';
      for (const it of setup) {
        const k = it && it[0];
        const v = it && it[1];
        if (k != null) map[String(k)] = Number.parseInt(v, 10) || 0;
      }
    } else {
      shape = 'array-objects';
      // skús odhadnúť názvy polí
      const candK = ['id','key','fid','field','k'];
      const candV = ['width','w','px','value','v'];
      if (setup[0] && typeof setup[0] === 'object') {
        keyName = candK.find(n => n in setup[0]) || 'id';
        valName = candV.find(n => n in setup[0]) || 'width';
      }
      for (const it of setup) {
        if (!it) continue;
        const k = it[keyName];
        const v = it[valName];
        if (k != null) map[String(k)] = Number.parseInt(v, 10) || 0;
      }
    }
  } else if (setup && typeof setup === 'object') {
    for (const [k, v] of Object.entries(setup)) {
      map[String(k)] = Number.parseInt(v, 10) || 0;
    }
  }

  return { map, shape, keyName, valName };
},

persistShowonSetup(map, shape, keyName='id', valName='width') {
  // zapíš späť v pôvodnom tvare
  if (shape === 'array-pairs') {
    this.$set(this.contenttype, 'showon_setup',
      Object.keys(map).map(k => [isNaN(+k) ? k : +k, map[k]])
    );
  } else if (shape === 'array-objects') {
    this.$set(this.contenttype, 'showon_setup',
      Object.keys(map).map(k => ({ [keyName]: isNaN(+k) ? k : +k, [valName]: map[k] }))
    );
  } else {
    this.$set(this.contenttype, 'showon_setup', { ...map });
  }
},


  widthPx(fid) {
    const s = this.contenttype && this.contenttype.showon_setup;
    if (!s) return 0;

    // 1) obyčajný objekt { "7": 280, ... }
    if (!Array.isArray(s) && typeof s === 'object') {
      const v = s[String(fid)] ?? s[fid];
      const n = Number.parseInt(v, 10);
      return Number.isFinite(n) ? Math.max(0, n) : 0;
    }

    // 2) pole párov [[7, 280], ...]
    if (Array.isArray(s) && Array.isArray(s[0])) {
      const hit = s.find(([k]) => String(k) === String(fid));
      const n = Number.parseInt(hit && hit[1], 10);
      return Number.isFinite(n) ? Math.max(0, n) : 0;
    }

    // 3) pole objektov [{id:7,width:280}, ...] (alebo {key,fid} / {width,w,px,value})
    if (Array.isArray(s) && s[0] && typeof s[0] === 'object') {
      const keyName = ['id','key','fid'].find(k => k in s[0]) || 'id';
      const valName = ['width','w','px','value','v'].find(k => k in s[0]) || 'width';
      const hit = s.find(it => String(it[keyName]) === String(fid));
      const n = Number.parseInt(hit && hit[valName], 10);
      return Number.isFinite(n) ? Math.max(0, n) : 0;
    }

    return 0;
  },

  setWidthPx(fid, val) {
    const rawN = Number.parseInt(val, 10);
    const px = Number.isFinite(rawN) ? Math.max(0, rawN) : 0;

    if (!this.contenttype.showon_setup) {
      this.$set(this.contenttype, 'showon_setup', {});
    }
    let s = this.contenttype.showon_setup;

    // 1) obyčajný objekt
    if (!Array.isArray(s) && typeof s === 'object') {
      this.$set(s, String(fid), px);
      return;
    }

    // 2) pole párov [[id, px], ...]
    if (Array.isArray(s) && Array.isArray(s[0])) {
      const i = s.findIndex(([k]) => String(k) === String(fid));
      if (i === -1) s.push([fid, px]);
      else s.splice(i, 1, [s[i][0], px]);
      return;
    }

    // 3) pole objektov
    if (Array.isArray(s) && s[0] && typeof s[0] === 'object') {
      const keyName = ['id','key','fid'].find(k => k in s[0]) || 'id';
      const valName = ['width','w','px','value','v'].find(k => k in s[0]) || 'width';
      const i = s.findIndex(it => String(it[keyName]) === String(fid));
      if (i === -1) s.push({ [keyName]: fid, [valName]: px });
      else this.$set(s[i], valName, px);
    }
  },



saveShowonSetup() {
  // Prípadne prerieď na iba vybrané polia:
  const sel = new Set((this.contenttype.showon || []).map(v => String(v)));
  const out = {};
  Object.keys(this.contenttype.showon_setup || {}).forEach(k => {
    if (sel.has(String(k))) {
      out[String(k)] = this.widthPx(k);
    }
  });
  // doplň newly selected, ktoré ešte nemajú kľúč
  sel.forEach(k => { if (!(k in out)) out[k] = 0; });

  this.$set(this.contenttype, 'showon_setup', out);
  this.showonSetupVisible = false;
  this.$message.success('Šírky uložené.');
},

           openImpModal (imp) {
    this.impSelected  = imp
    this.impFileUri   = ''
    this.impModal     = true
  },
  async uploadRealFile ({ file, onSuccess, onError }) {
    try {
      this.impUploading = true
      const fd = new FormData()
      fd.append('upload', file)
      const r  = await this.axios.post(
        this.url.API_URL + '/upload/content',
        fd, { headers: authHeader(true) })
      this.impFileUri   = r.data[0].uri        // ← uložíme URL
      onSuccess()
    } catch (e) { onError(e) }
    finally     { this.impUploading = false }
  },
  async runImport () {
    if (!this.impSelected || !this.impFileUri) return

    const payload = {
      definitionId : this.impSelected.id,   // ← ID šablóny
      fileUri      : this.impFileUri        // ← reálny XLSX
    }

    await dataService.axiosPost('contenttype/runImport', payload)
    this.$message.success('Import bol spustený.')
    this.impModal = false
  },
async saveMapping () {
  const empty = this.mappings.some(m =>
    m.parts.some(p => p.fieldId === null)
  )
  if (empty) {
    this.$message.error('Vyplň všetky selecty alebo ich odstráň.')
    return
  }

   const payload = {
    // pre update
    ...(this.mappingId ? { id: Number(this.mappingId) } : {}),

    fileUri      : this.uploadedXlsxUrl,
    startRow     : this.previewRow,
    ignoreHeader : this.ignoreHeader,
    uploadName   : this.uploadName,
    contentTypeId: this.id,

    keyField     : this.keyField,
    existingBehavior: this.existingBehavior,

    mappings: this.mappings.map(({
      col, sep, parts, createMissingTerm, ignoreIfNoLocal,  matchBySlug}) => ({
      col,
      sep,
      parts: parts
        .filter(p => p.fieldId !== 'IGNORE')
        .map(p => ({ fieldId: p.fieldId })),
      ...(createMissingTerm ? { createMissingTerm } : {}),
      ...(ignoreIfNoLocal   ? { ignoreIfNoLocal   } : {}),
      ...(matchBySlug       ? { matchBySlug }       : {})
    }))
  };

  await dataService.axiosPost('contenttype/importXlsx', payload);
  this.$message.success(
    this.mappingId
      ? 'Import bol aktualizovaný.'
      : 'Import bol vytvorený.'
  );
this.fetch();
  // reset stavu
  this.mappingId = null;
},
 renderSelect (colIdx) {
  const map = this.mappings.find(m => m.col === colIdx)

  /* ▸  helper – či aspoň jeden part je taxonomické pole (type 12) */
const hasTaxonomyField = map.parts.some(p => {
  /* previesť id z poľa aj partu na číslo (alebo na string – je to jedno,
     hlavné je, aby mali rovnaký typ) */
  const f = this.contenttype.fields.find(
    x => Number(x.id) === Number(p.fieldId)
  )
  return f && String(f.type) === '12'
})

const hasType8Field = map.parts.some(p => {
  const f = this.contenttype.fields.find(x => Number(x.id) === Number(p.fieldId))
  return f && String(f.type) === '8'
})

const isMultiField = map.parts.some(p => {
  const f = this.contenttype.fields.find(x => Number(x.id) === Number(p.fieldId))
  console.log(f.multi);
  return f && f.multi == '1'
})

  /* ▸  MODAL s nastaveniami */
  const openSettings = () => {
    Modal.confirm({
      title : 'Nastavenia importu stĺpca',
      width : 420,
      okText: 'Uložiť',
      cancelText: 'Zrušiť',
      content: () => this.$createElement('div', [

        /* separátor – len ak je viac partov */
        (map.parts.length > 1 || isMultiField) && this.$createElement('div',
          { style:{ marginBottom:'12px' } }, [
            this.$createElement('p',
              { style:{ margin:'0 0 4px' } }, 'Separátor medzi hodnotami'),
            this.$createElement('a-input', {
              props:{ value: map.sep },
              style:{ width:'120px' },
              on  :{ input:e => { map.sep = e.target.value || ' ' } }
            })
          ]),


          hasType8Field && this.$createElement(
  'div',
  { style:{ marginTop:'14px' } },
  [
    this.$createElement('p', { style:{ margin:'0 0 4px' } },
      'Slug poľa na párovanie (v priradenom type obsahu)'),
    this.$createElement('a-input', {
      props : { value: map.matchBySlug },
      on    : { input: e => { map.matchBySlug = e.target.value.trim() } }
    })
  ]
),


 hasTaxonomyField && this.$createElement(
        'div',
        { class: 'taxonomy-settings' },
        [
          this.$createElement('a-checkbox', {
            props: { checked: map.createMissingTerm },
            on:    { change: e => { map.createMissingTerm = e.target.checked } }
          }, ['Vytvoriť taxonomický termín, ak neexistuje']),

          this.$createElement('a-checkbox', {
            props: { checked: map.ignoreIfNoLocal },
            on:    { change: e => { map.ignoreIfNoLocal = e.target.checked } }
          }, ['Ignoruj riadok, ak neexistuje lokálna hodnota'])
        ]
      )
      ])
    })
  }

  /* ▸  renderer jedného riadku (partu) */
  const makeRow = (part, idx) => {
    const isFirst = idx === 0
    const isLast  = idx === map.parts.length - 1

    /* samotný SELECT */
    const select = this.$createElement('a-select',
      {
        props:{
          value: part.fieldId != null ? String(part.fieldId) : undefined,
          allowClear: true,
          getPopupContainer: () => document.body
        },
        style:{ flex:'1 1 auto', marginRight:'6px' },
        on:{
          change:v => {
            part.fieldId =
              v === undefined ? null :
              v === 'IGNORE'  ? 'IGNORE' :
              Number(v)
          }
        }
      },
      [
        this.$createElement('a-select-option',
          { props:{ value:'IGNORE' } }, '— ignorovať —'),

        ...this.contenttype.fields
          .filter(f => f.type !== 20 && f.id)
          .map(f =>
            this.$createElement('a-select-option',
              { props:{ value:String(f.id) } }, f.title))
      ])

    /* pravé tlačidlo – ⚙️ alebo ➖ */
    const rightBtn = isFirst
      ? this.$createElement('a-button', {
          props:{ icon:'setting', size:'small', type:'link' },
          on:{ click: openSettings }
        })
      : this.$createElement('a-button', {
          props:{ icon:'minus', size:'small', type:'link' },
          on:{ click:() => map.parts.splice(idx,1) }
        })

    /* + pridáva len posledný riadok */
    const addBtn = isLast
      ? this.$createElement('a-button', {
          props:{ icon:'plus', size:'small', type:'link' },
          on:{ click:() => map.parts.push({ fieldId:null }) }
        })
      : null

    return this.$createElement('div', {
      style:{ display:'flex', alignItems:'center', marginBottom:'4px' }
    }, [select, rightBtn, addBtn].filter(Boolean))
  }

  /* ▸  výsledok pre celú bunku tabuľky */
  return this.$createElement('div', map.parts.map(makeRow))
},
            nodeclicked: function(args) {
                if (args.event.which === 3) {
                    var treeObj = document.getElementById('treeview').ej2_instances[0];
                    treeObj.selectedNodes = [args.node.getAttribute('data-uid')];
                }
            },menuclick: function(args) {
                var treevalidate = document.getElementById('treeview').ej2_instances[0];
                var targetNodeId = treevalidate.selectedNodes[0];
                if (args.item.text === "Upraviť") {
                this.openFieldModal(this.allFields[targetNodeId]);
                }
                else if (args.item.text === "Zmazať") {
                    this.confirm(targetNodeId);
                }
            },
            beforeopen: function() {
                var treevalidate = document.getElementById('treeview').ej2_instances[0];
                var targetNodeId = treevalidate.selectedNodes[0];
                var targetNode = document.querySelector('[data-uid="' + targetNodeId + '"]');
                var contentmenutree = document.getElementById('contentmenutree').ej2_instances[0];
                if (targetNode.classList.contains('remove')) {
                    contentmenutree.enableItems(['Zmazať'], false);
                }
                else {
                    contentmenutree.enableItems(['Zmazať'], true);
                }
            },
            nodeDrag(args) {

                if (args.droppedNode.getElementsByClassName('icon-20').length === 0 && args.droppedNode != null && args.dropIndicator === 'e-drop-in') {
                  args.dropIndicator = 'e-no-drop';
              }
            },
            dragStop(args) {

   if (args.droppedNode.getElementsByClassName('icon-20').length === 0 && args.dropIndicator === 'e-no-drop') {
                        args.cancel = true;
                    }

            },
            updateFields(e)
            {
                let sendata = e.data;
                dataService.axiosPost('reordergroupfields/' + this.id, sendata).then(() => {
                });
            },
              addTerm()
            {
                dataService.axiosPost('addfieldtaxonomy/grouping', { 'title' : this.newTermToAdd}).then(results => {
                this.grouping.push({value:results.data[0],label: this.newTermToAdd});
                this.groupField.groupID = results.data[0];
                this.newTermToAdd = "";
                });
            },
            openFieldModal(id = false){
 if (
      id.type === '2' &&
      this.contenttype.options &&
      this.contenttype.options[id.id]
    ) {
      // Map incoming options from { value, label } to { title, slug }
      this.newField.options = this.contenttype.options[id.id].map(option => {
        return { title: option.label, slug: option.slug };
      });
      // Create keys based on the length of the options array (e.g., [0, 1, 2, ...])
      const optionKeys = this.newField.options.map((opt, index) => index);
      this.form.setFieldsValue({ keys: optionKeys });
    }

if(id.type === "8" || id.type === "28")
{

  if(this.contexts[id.id] > 0)
{
  dataService.axiosFetch('contenttype', this.contexts[id.id]).then(results => {
                    this.subfields = results.fields;
                });
}

}


if(parseInt(id.id) > 0)
{
    this.newField = id;
}
else {
    this.newField = {title : null,type : null, blocks: [],options : [{title: '',slug: ''}], fieldcolection: {'title':[],'type':[],'setup':[]}, multi: false, slug : null,content_id : this.id };
}
              this.addFieldModal = true;
            },
            openGroupModal(id = false){
                if(parseInt(id.id) > 0)
                {
                    this.groupField.groupID = id;
                }
                else {
                    this.groupField = { groupID : null, content_id : this.id  };
                }
                this.addGroupModal = true;
            },
            confirm(e) {
                dataService.axiosDelete('contenttypefields', e).then(results => {
                    if (results) {
                     this.fetch();
                    }
                });
            },
            onChange(checked) {
                this.newField.multi = checked;
            },
            cancel() {
            },
            updateOrderFields()
            {
                dataService.axiosPost('reorderfields/' + this.id, this.contenttype.fields).then(() => {

                });
            },
            saveReorder()
            {
                dataService.axiosPost('reorderblocks/' + this.id, this.contenttype.blocks).then(() => {

                });
                    },
                    async importExampleFile(e) {
      let formData = new FormData();
      formData.append('upload', e.file);
      formData.append('ctype', this.id);

      this.axios.post(this.url.API_URL + '/upload/content', formData, {
        headers: authHeader(true)
      }).then(async (data) => {
        const fileUri = data.data[0].uri
        this.uploadedXlsxUrl = fileUri
        const fileName = decodeURIComponent(fileUri.split('/').pop())
        this.uploadName = fileName
        await this.parseWorkbook(fileUri)
      })
    },

async parseWorkbook (url) {
  const res = await this.axios.get(url, { responseType: 'arraybuffer' })
  const wb  = XLSX.read(res.data, { type: 'array' })
  const ws  = wb.Sheets[wb.SheetNames[0]]

  this.sheetRows = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false })

  /* koľko stĺpcov má najdlhší riadok s obsahom */
  const cols = Math.max(
    ...this.sheetRows.map(r =>
      r.reduce((last, c, i) => (String(c).trim() !== '' ? i : last), -1) + 1),
    0)

  if (!cols) {
    this.$message.warning('V XLSX nevidím žiadne dáta.')
    this.mappings = []
    return
  }

  /* ⬇️ nové defaulty – sep + createMissingTerm ----------------- */
  this.mappings = Array.from({ length: cols }, (_, col) => ({
    col,
    sep  : ' ',               // predvolený separátor
    parts: [ { fieldId:null } ],
    createMissingTerm: false,
    ignoreIfNoLocal     : false,
    matchBySlug      : ''
  }))
},
            handleChange() {

            },
            remove(k) {
                const { form } = this;
                // can use data-binding to get
                const keys = form.getFieldValue('keys');
                // We need at least one passenger
                if (keys.length === 1) {
                    return;
                }

                // can use data-binding to set
                form.setFieldsValue({
                    keys: keys.filter(key => key !== k),
                });
            },

            updateBlocks() {

            },
            add() {
                const { form } = this;
                // can use data-binding to get
                const keys = form.getFieldValue('keys');
                const nextKeys = keys.concat(id++);
                // can use data-binding to set
this.newField.options.push({ title: '', slug: ''});

                // important! notify form to detect changes
                form.setFieldsValue({
                    keys: nextKeys,
                });
            },
           handleSubmit() {
  this.contenttype.multi = this.contenttype.multibool;

  const payload = {
    ...this.contenttype,
    showon: (this.contenttype.showon || []).map(v => Number(v)), // server často chce čísla
  };

  dataService.axiosPost('contenttype', payload).then(results => {
    if (results.data && isNaN(this.id)) {
      this.contenttype = {};
      this.$router.push('/content-type/' + results.data.message);
    }
    this.addFieldModal = false;
  });
},
            handleNewGroupSubmit()
            {
                this.addFieldModal = false;
                let $contenttype_data = this.groupField;
                dataService.axiosPost("contenttype/newGroup", $contenttype_data).then(results => {
                    if(results.data.data)
                    {
                     this.fetch();
                    }
                });
            },
            handleNewFieldSubmit()
            {  this.addFieldModal = false;
                this.newField.multi = this.newField.multibool;
                this.newField.independent = this.newField.independentbool;
                this.newField.schedulable = this.newField.schedulablebool;
                this.newField.filterable = this.newField.filterablebool;
                this.newField.historic = this.newField.historicbool;
                this.newField.extra = this.newField.extrabool;


                this.newField.translatable = this.newField.translatablebool;
                this.newField.translate = this.newField.translatebool;
                let $contenttype_data = this.newField;
                dataService.axiosPost("contenttype/newfield", $contenttype_data).then(results => {

                        this.fetch();

                });
            },
            fetch()
            {
                dataService.axiosFetch('contenttype', this.id).then(results => {
                    this.contenttype = results;
                    this.contexts = results.context;

                    this.fields = { dataSource: this.contenttype.groups, id: 'id', text: 'url', parentId: 'pid',iconCss: 'icon', url: 'name',child: 'child', selected: 'isSelected' };
                    var roleops = [];
                    results.fields.forEach(obj => { roleops.push({"value" : obj.id + '' , "label" : obj.title}); });

                    this.fieldStoShow = roleops;

                    if (!this.contenttype.showon_setup) {
  this.$set(this.contenttype, 'showon_setup', {});
}


                    roleops = [];
                    results.fields.forEach(obj => {

                        roleops[obj.id] = obj;

                    });

                    this.allFields = roleops;


                });
            },

},

        mounted() {
            if (!isNaN(this.id)) {
         this.fetch();
            }


            dataService.axiosFetch('extrauserfields').then(results => {
                    var roleops = [];
                    roleops.push({"value" : '' , "label" : 'Nelimitovať'});
                    results.fields.forEach(obj => { roleops.push({"value" : obj.id , "label" : obj.title}); });
                    this.userFields = results.fields;
            });

            dataService.axiosFetch('imports',this.id).then(results => {
                this.imports = results;
            });
            dataService.axiosFetch('taxonomies').then(results => {
                this.taxonomies = results;
                  var roleops = [];
                results.forEach(obj => { roleops.push({"value" : obj.id , "label" : obj.title}); });
this.taxs = roleops;
                this.loading = false;
            });
            dataService.axiosFetch('listof','basic_page').then(results => {

                this.ctnodes = results;
                this.loading = false;
            });

            dataService.axiosFetch('taxonomyitems',"product_category").then(results => {

                var roleops = [];
                roleops.push({"value" : '0' , "label" : 'Nie je produkt'});
                if(results)
                results.forEach(obj => { roleops.push({"value" : obj.id , "label" : obj.title}); });

                this.productCat = roleops;
                this.loading = false;
            });


            dataService.axiosFetch('taxonomyitems',"grouping").then(results => {

                var roleops = [];
                if(results)
                 results.forEach(obj => { roleops.push({"value" : obj.id , "label" : obj.title}); });

                this.grouping = roleops;
            });

            dataService.axiosFetch("contenttypes").then(results => {
                this.contenttypes = results;
                this.loading = false;
            });
        }
    };
</script>
<style scoped>
    @import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
    @import "../../node_modules/@syncfusion/ej2-vue-navigations/styles/material.css";
    @import "../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
    .control_wrapper >>> .e-treeview .e-text-content .e-list-text
    {width:100%;}

   .control_wrapper >>> .e-treeview:not(.e-fullrow-wrap) .e-list-item.e-hover > .e-text-content
    {box-shadow:0 0;
    border-color:transparent;}
    .control_wrapper >>> .e-treeview .e-text-content .e-list-text .treeviewdiv
    {
        width:100%;  padding-top:5px;border-top:1px solid #f1f1f1;
    }
    .control_wrapper >>> .e-treeview .e-text-content .e-list-text .treeviewdiv:hover
    {color:#000;}
    .control_wrapper >>> .e-treeview:not(.e-fullrow-wrap) .e-list-item.e-active > .e-text-content
    {box-shadow:0 0;
        border-color:transparent;}
    .control_wrapper >>> .e-treeview .e-list-item.e-active > .e-text-content .e-list-text
    {color: #525f7f;}
    .control_wrapper >>> .e-treeview .e-list-icon,.control_wrapper >>>  .e-treeview .e-list-img
    {display:none}
    .control_wrapper >>> .e-treeview:not(.e-fullrow-wrap) .e-list-item > .e-text-content
    {padding:0;background-color:transparent!important;color:#525f7f!important;}
    .control_wrapper >>> .e-treeview .e-ul:not(.e-list-parent)
    {padding:0;}
    .control_wrapper >>> .e-treeview > .e-ul
    {overflow-x:hidden;
    max-width:100%;}

    .control_wrapper >>> .e-treeview .e-ul .tree-column
    {width:33.33%;}

    .control_wrapper >>> .e-treeview .e-ul .type-20 .treeviewdiv
    {background-color: #ffffff; color:#525f7f!important;padding-left:5px;
    }
    .input-group .input-group-prepend .input-group-text {
        border: 0;
    }
    .dynamic-delete-button {
        cursor: pointer;
        position: relative;
        top: 4px;
        font-size: 24px;
        color: #999;
        transition: all 0.3s;
    }
    .dynamic-delete-button:hover {
        color: #777;
    }
    .dynamic-delete-button[disabled] {
        cursor: not-allowed;
        opacity: 0.5;
    }
    .element
    {display:block;width:100%; border-top-left-radius: 5px;border-top-right-radius:5px;overflow:hidden;}

    .element
    {
        padding:0;
        border-radius:0;border: 1px solid #eeeeee;
        margin-bottom:-1px;
    }
     .taxonomy-settings
     {margin-top:20px;}
    .taxonomy-settings .ant-checkbox-wrapper
    {
      display:block;
      width:100%;
      margin-left:0;
      margin-bottom:10px;
      text-align:left;
    }
    .ant-table-body
    {width:100%}
    .manager
    {width:800px}
    .top-holder
    {width:100%;border:1px solid #eceff3; padding:15px   }
    .element-image
    {width:100%; border-bottom:1px solid #eceff3; padding-bottom:10px;margin-bottom:10px;}

    .element .handle
    {font-size:18px;padding:5px; padding-right:15px;
        display: inline-block;}
    .element span
    {width:100%; display:block; text-align:left; min-height:30px; font-size:12px; background-color: #fff;}
    .edit-button
    {float:right;  border-radius:0px;   border: 0;
        padding-top:4px;
    }
    .ant-select-selection--single
    {width:100%;
        height: calc(1.5em + 1.25rem + 2px);
        padding: 0.625rem 0.75rem;}

</style>
